import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-layout" }

import TopHeader from '@/components/Header.vue';
import NavigationBar from '@/components/MyNav.vue';
import bottomView from '@/components/bottomView.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'BaseLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TopHeader),
    _createVNode(NavigationBar),
    _createVNode(_component_router_view),
    _createVNode(bottomView)
  ]))
}
}

})